/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-unsafe-optional-chaining */
import React, { useEffect } from 'react';
import { AuthUserState } from '../../../redux/features/authSlice';
import { useAppSelector } from '../../../redux/hooks';
import { useLocation, useNavigate } from 'react-router-dom';
import { Routes } from 'common/router-name';
import useNotification from 'hooks/useNotification';
import useDispatchQueueCallSocket from 'hooks/useDispatchQueueCallSocket';
import { toast } from 'react-toastify';
import { stopIncomingCallSound } from 'utils/incomingCallSound';
const CallNotification: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const pathname = location.pathname;
  const authUser = useAppSelector(state => state.auth.user) as AuthUserState;
  const { requestPermission, sendNotification } = useNotification();

  const { call } = useDispatchQueueCallSocket();
  useEffect(() => {
    requestPermission();
  }, []);

  const hasNotification =
    authUser.user_type === 'DS' &&
    (call?.type === 'existing_calls' || call?.type === 'new_call') &&
    call?.call_data &&
    authUser.accept_calls &&
    pathname !== Routes.PendingUserQue;

  useEffect(() => {
    if (hasNotification && call?.type === 'new_call') {
      sendNotification(
        'New Notification!',
        {
          body: 'URGENT INCOMING CALL.',
          icon: `${window.location.origin}/favicon.png` // Optional: icon URL
        },
        () => {
          stopIncomingCallSound();
          navigate(Routes.PendingUserQue);
        }
      );
    }
  }, [hasNotification, call]);

  /** Persistent toast: stops looping MP3 when dismissed or clicked (same as “toast” control). */
  useEffect(() => {
    const callId = call?.call_data?.call_id;
    if (
      call?.type !== 'new_call' ||
      !callId ||
      authUser.user_type !== 'DS' ||
      !authUser.accept_calls
    ) {
      return;
    }

    const toastId = `incoming-call-${callId}`;

    toast.info('URGENT INCOMING CALL — Click to open queue', {
      toastId,
      autoClose: false,
      closeOnClick: true,
      onClick: () => {
        stopIncomingCallSound();
        navigate(Routes.PendingUserQue);
      },
      onClose: () => {
        stopIncomingCallSound();
      }
    });
  }, [call, authUser.user_type, authUser.accept_calls, navigate]);

  // Stop the looping sound once the call is no longer "pending as a new_call" (e.g. dispatcher joined / call ended).
  useEffect(() => {
    const callId = call?.call_data?.call_id;
    if (!callId) return;
    if (call?.type === 'new_call') return;
    if (call?.type === 'existing_calls') return;

    stopIncomingCallSound();
    toast.dismiss(`incoming-call-${callId}`);
  }, [call?.type, call?.call_data?.call_id]);
  return (
    <>
      {hasNotification && (
        <p
          className="p-3 fw-semibold cursor-pointer"
          style={{
            color: '#ffffff',
            backgroundColor: '#F48B8B',
            marginTop: '-32px',
            marginLeft: '-130px',
            marginRight: '-40px',
            textAlign: 'center',
            transition: '1s'
          }}
          onClick={() => {
            stopIncomingCallSound();
            const id = call?.call_data?.call_id;
            if (id) {
              toast.dismiss(`incoming-call-${id}`);
            }
            navigate(Routes.PendingUserQue);
          }}
        >
          INCOMING CALL - YOU WILL BE REDIRECTED TO THE USER
        </p>
      )}
      {/* <div>
        <h2>WebSocket Chat (TypeScript)</h2>
        <div
          style={{
            border: '1px solid #ccc',
            padding: '10px',
            height: '200px',
            overflowY: 'scroll'
          }}
        >
          <h4>Messages:</h4>
          {messages.length > 0 ? (
            messages.map((msg, index) => <div key={index}>{msg}</div>)
          ) : (
            <p>No messages yet...</p>
          )}
        </div>
      </div> */}
    </>
  );
};

export default CallNotification;
